import React from "react";
import styled from "styled-components";
import { FaUsers, FaPiggyBank, FaFileInvoice, FaMoneyCheckAlt, FaCalendarCheck, FaDesktop, FaLayerGroup, FaShieldAlt, FaMoneyBill, FaMobile } from "react-icons/fa";

const features = [
  { icon: <FaUsers />, title: "Member Management", desc: "Easily manage member info, roles, and statuses." },
  { icon: <FaPiggyBank />, title: "Contribution Tracking", desc: "Track all contributions, penalties, and deposits." },
  { icon: <FaMoneyCheckAlt />, title: "Loan Management", desc: "Approve, disburse, and track loans transparently." },

  { icon: <FaMoneyBill />, title: "Dividend Distribution", desc: "Declare and distribute dividends to shareholders based on their shares and management decisions." },

    { icon: <FaMobile />, title: "M-PESA and SMS Integration", desc: "Support automatic M-PESA payment and reconciliation and messaging." },

  { icon: <FaFileInvoice />, title: "Automated Reports", desc: "Generate financial summaries with one click." },
  { icon: <FaCalendarCheck />, title: "Payout Scheduling", desc: "Plan payouts or merry-go-rounds with ease." },
  { icon: <FaDesktop />, title: "Offline-first App", desc: "Work without internet. Sync when ready." },
  { icon: <FaLayerGroup />, title: "Multi-group Support", desc: "Run multiple chamas or SACCOS from one app." },
  { icon: <FaShieldAlt />, title: "Secure & Private", desc: "Your data stays safe and encrypted." },
];

export default function FeaturesSection() {
  return (
    <SectionWrapper id="features" className="lightBg">
      <div className="container">
        <h2 className="font40 extraBold textCenter" style={{ color: "purple" }}>
          Powerful Features for Your Group
        </h2>
        <p className="font16 textCenter" style={{ maxWidth: "700px", margin: "20px auto" }}>
          Everything your Chama, SACCO, or financial group needs to grow together — organized, secure, and easy to use.
        </p>
        <FeatureGrid>
          {features.map((item, index) => (
            <FeatureCard key={index}>
              <IconWrapper>{item.icon}</IconWrapper>
              <h3 className="font18 extraBold">{item.title}</h3>
              <p className="font14">{item.desc}</p>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </div>
    </SectionWrapper>
  );
}

const SectionWrapper = styled.section`
  padding: 80px 0;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const FeatureCard = styled.div`
  background: #fff;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.06);
  text-align: center;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.08);
  }
`;

const IconWrapper = styled.div`
  font-size: 36px;
  color: purple;
  margin-bottom: 15px;
`;
